module.exports = "<p>\r\n  route-location works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/locations/route-location/route-location.component.html
// module id = ../../../../../src/app/_components/locations/route-location/route-location.component.html
// module chunks = 1